/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Transition from 'react-transition-group/Transition'
import { cx } from '@emotion/css'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import AccessibleIcon from '../AccessibleIcon'
import styles, { wrapperTransition, containerTransition, headerTheme, iconColor } from './styles'

class Popup extends Component {
  constructor(props) {
    super(props)
    this.scrollElement = document.scrollingElement || document.documentElement
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.scrollElement.style.overflow = 'hidden'
    } else if (!this.props.visible && prevProps.visible) {
      this.scrollElement.style.overflow = ''
    }
  }

  componentWillUnmount() {
    this.scrollElement.style.overflow = ''
  }

  handleHidePopup = () => {
    if (!this.props.preventClose) this.props.hidePopup()
  }

  render() {
    const { visible, onPopupClose, theme, title, children } = this.props
    return (
      <Transition in={visible} timeout={{ enter: 0, exit: 300 }} mountOnEnter unmountOnExit onExited={onPopupClose}>
        {status => (
          <div className={cx(styles.wrapper, wrapperTransition(status))}>
            <div onClick={this.handleHidePopup} className={styles.overlay} />

            <div className={cx(styles.container, containerTransition(status))}>
              <div className={cx(styles.header, headerTheme(theme))}>
                <div>{title}</div>
                <button type="button" onClick={this.handleHidePopup}>
                  <AccessibleIcon icon={CloseIcon} color={iconColor(theme)} size={20} />
                  <span className={styles.accessiblyHidden}>Close</span>
                </button>
              </div>

              {Boolean(children) && children({ hidePopup: this.handleHidePopup })}
            </div>
          </div>
        )}
      </Transition>
    )
  }
}

Popup.propTypes = {
  title: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  onPopupClose: PropTypes.func,
  preventClose: PropTypes.bool,
  children: PropTypes.func,
  hidePopup: PropTypes.func,
  visible: PropTypes.bool,
}

Popup.defaultProps = {
  theme: 'primary',
}

export default Popup
